export const PAY_LATER = "PAY_LATER";

export const MODAL_TYPES = {
  ENABLE: 'enable' as const,
  DISABLE: 'disable' as const
}

export const sortByRank = <T extends { rank: number; group_rank?: number }>(
  items: T[],
  sortBy: 'rank' | 'group_rank' = 'rank'
): T[] => items.sort((a, b) => (a[sortBy] ?? 0) - (b[sortBy] ?? 0));